// Test IDs for self-service signup (clients + invite-gated photographers)
// and admin Team management (invite generation/revocation, client activation).

export const SIGNUP_CLIENT_PAGE = {
  root: 'signup-client-page',
  nameInput: 'signup-client-name-input',
  emailInput: 'signup-client-email-input',
  passwordInput: 'signup-client-password-input',
  submitButton: 'signup-client-submit-button',
  errorText: 'signup-client-error-text',
  loginLink: 'signup-client-login-link',
};

export const SIGNUP_PHOTOGRAPHER_PAGE = {
  root: 'signup-photographer-page',
  inviteCodeInput: 'signup-photographer-invite-code-input',
  nameInput: 'signup-photographer-name-input',
  emailInput: 'signup-photographer-email-input',
  passwordInput: 'signup-photographer-password-input',
  submitButton: 'signup-photographer-submit-button',
  errorText: 'signup-photographer-error-text',
  loginLink: 'signup-photographer-login-link',
};

export const ADMIN_TEAM = {
  section: 'admin-team-section',
  memberRow: (id) => `admin-team-member-${id}`,
  inviteButton: 'admin-team-invite-button',
  inviteDialog: 'admin-team-invite-dialog',
  inviteExpirySelect: 'admin-team-invite-expiry-select',
  inviteEmailInput: 'admin-team-invite-email-input',
  inviteGenerateButton: 'admin-team-invite-generate-button',
  inviteUrlText: 'admin-team-invite-url-text',
  inviteCopyButton: 'admin-team-invite-copy-button',
  inviteRevokeButton: (id) => `admin-team-invite-revoke-${id}`,
  pendingInviteRow: (id) => `admin-team-pending-invite-${id}`,
  searchInput: 'admin-team-search-input',
  lastLogin: (id) => `admin-team-last-login-${id}`,
};

export const ADMIN_CLIENT_EDIT = {
  editButton: (id) => `admin-client-edit-button-${id}`,
  dialog: 'admin-client-edit-dialog',
  nameInput: 'admin-client-edit-name-input',
  gallerySelect: 'admin-client-edit-gallery-select',
  saveButton: 'admin-client-edit-save-button',
  activatedBadge: (id) => `admin-client-activated-badge-${id}`,
};
